import http from 'axios'
import urls from './manageClientDocument.urls'

export default {
  getClientDocuments: ({ state, rootState, commit }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .get(urls.getClientDocuments)
      .then(response => {
        commit('global/setShowLoadingSpinner', false, { root: true })
        return response
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  },
  deleteClientDocument: ({ state, rootState, commit, dispatch }, documentId) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .delete(urls.changeClientDocument(documentId))
      .then(() => {
        commit('global/setShowLoadingSpinner', false, { root: true })
        return dispatch('getClientDocuments')
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  },
  changeClientDocument: ({ state, rootState, commit, dispatch }, data) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    const formData = new FormData()
    for (var key in data) {
      formData.append(key, data[key])
    }
    return http
      .post(data.documentId ? urls.changeClientDocument(data.documentId) : urls.addClientDocument, formData)
      .then(() => {
        commit('global/setShowLoadingSpinner', false, { root: true })
        return dispatch('getClientDocuments')
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  },
  getClientDocumentGroups: ({ state, rootState, commit }, documentId) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .get(urls.getClientDocumentGroups(documentId))
      .then(response => {
        commit('global/setShowLoadingSpinner', false, { root: true })
        return response
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  },
  addClientDocumentGroup: ({ state, rootState, commit, dispatch }, { documentId, userGroupId }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .post(urls.addClientDocumentGroup, null, { params: { documentId: documentId, userGroupId: userGroupId } })
      .then(() => {
        commit('global/setShowLoadingSpinner', false, { root: true })
        return dispatch('getClientDocumentGroups', documentId)
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  },
  deleteClientDocumentGroup: ({ state, rootState, commit, dispatch }, { documentId, userGroupId }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .delete(urls.deleteClientDocumentGroup(documentId, userGroupId))
      .then(() => {
        commit('global/setShowLoadingSpinner', false, { root: true })
        return dispatch('getClientDocumentGroups', documentId)
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  }
}
